module.exports = __webpack_public_path__ + "img/bg_xlsx_cover.127527c2.png";